import { h } from 'preact';
import { IconCheckmark } from './icon-checkmark';
export const AddToList = function({ name , onNameChange , onToggle , disabled , selectedByLid , wishlists , loading  }) {
    return h('div', {
        className: 'wishlist__add-to-list',
        role: 'group',
        'aria-label': 'Add to wishlist'
    }, [
        h('div', {
            className: 'wishlist__add-to-list-container'
        }, wishlists && wishlists.map((wishlist)=>h('label', {
                key: wishlist.lid,
                className: 'wishlist__add-to-list-item' + (loading ? ' wishlist__add-to-list-item--loading' : ''),
                htmlFor: `wishlist-${wishlist.lid}`
            }, [
                h('div', {
                    className: 'wishlist__add-to-list-info'
                }, [
                    h('input', {
                        type: 'checkbox',
                        id: `wishlist-${wishlist.lid}`,
                        className: 'wishlist__add-to-list-checkbox wishlist__add-to-list-checkbox--hidden',
                        value: wishlist.lid,
                        checked: !!selectedByLid[wishlist.lid],
                        disabled: !!disabled || !!loading,
                        onChange: (event)=>onToggle(wishlist.lid, event.currentTarget.checked)
                    }),
                    h('span', {
                        className: 'wishlist__add-to-list-visual'
                    }, [
                        h(IconCheckmark, {})
                    ]),
                    h('p', {
                        className: 'wishlist__add-to-list-title'
                    }, wishlist.lname)
                ]),
                h('div', {
                    className: 'wishlist__add-to-list-image'
                }, [
                    wishlist.listcontents.slice(0, 4).map((item)=>{
                        return h('img', {
                            src: item.iu || '',
                            alt: item.dt,
                            className: 'wishlist__add-to-list-image-tile'
                        });
                    })
                ])
            ])))
    ]);
};
